export const ALERT_TEXT_FOLLOW_NOT_ALLOWED = 'フォローは許可されていません。'
